import { useEffect } from 'react'

// Needed since scroll smooth disables the browser errors https://issues.chromium.org/issues/40196176
const useSmoothScrollFix = () => {
  useEffect(() => {
    const removeSmoothScrollTemporarily = () => {
      document.documentElement.classList.remove('scroll-smooth')
      setTimeout(
        () => document.documentElement.classList.add('scroll-smooth'),
        100,
      )
    }

    document.addEventListener('invalid', removeSmoothScrollTemporarily, true)
    return () => {
      document.removeEventListener(
        'invalid',
        removeSmoothScrollTemporarily,
        true,
      )
    }
  }, [])
}

export default useSmoothScrollFix
